import FlybitsOverlay from "../components/flybits-overlay";
import ActionLink from "../models/actionLink";

const OutletManager = {
  $overlay: null,
  /**
   * 
   * @param {string} actionLink Action Link protocol string
   * @param {HTMLElement|string} $outlet Either an HTML element to inject the outlet into or a query selector string by which to query the HTML element.
   * @param {Object} parent Parent FlybitsSlot instance to align overlay attributes to.
   * @returns {undefined}
   */
  openOverlay: function(actionLink, $outlet, parent){
    if(!this.$overlay){
      this.$overlay = new FlybitsOverlay();
    }

    if(actionLink.protocol === ActionLink.protocol.DETAILS && !actionLink.data.content){
      this.$overlay.logger.error('no content details to display')
      return;
    }

    if(actionLink.protocol === ActionLink.protocol.CONCIERGE && !actionLink?.params?.zoneReferenceId){
      this.$overlay.logger.error('no zone reference ID')
      return;
    }
    
    const existingLoadingUI = this.$overlay.querySelector('[slot="loading"]');
    if(existingLoadingUI){
      existingLoadingUI.remove();
    }

    const existingErrorUI = this.$overlay.querySelector('[slot="error"]');
    if(existingErrorUI){
      existingErrorUI.remove();
    }

    this.$overlay._adoptSlotContext(parent);

    var $outletEl = $outlet;
    if(typeof $outlet === 'string'){
      $outletEl = document.querySelector($outlet);
    }

    if(!$outletEl){
      this.$overlay.logger.error('invalid outlet', $outlet)
      return;
    }
    $outletEl.append(this.$overlay);

    if(actionLink.protocol === ActionLink.protocol.DETAILS){
      this.$overlay.injectContent(actionLink.data.content);
    } else if(actionLink.protocol === ActionLink.protocol.CONCIERGE){
      this.$overlay.handleAction(actionLink);
    } else {
      this.$overlay.logger.error('ActionLink type not yet supported in overlay', actionLink.rawStr);
    }
  }
};

export default OutletManager;